<template>
  <div class="orderList">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="topColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
      @dblclickEvent="childDblclickEvent"
      @handleChange="handleChange"
      @changeMethod="changeMethod"
    ></sirui-search>
    <div class="main-content">
      <div class="top-box">
        <div class="card-btn">
          <div class="text">切换视图</div>
          <CardBtn :listType="listType" @changeListType="changeListType" />
        </div>
        <div class="btnList">
          <div v-for="(item, i) in menuButtonList" :key="i">
            <vxe-button
              v-if="item.type == '0'"
              class="btn"
              type="primary"
              @click="chooseClick(item.attributes.buttonUrl)"
              >{{ item.label }}</vxe-button
            >
          </div>
        </div>
      </div>
      <sirui-table
        v-show="listType === '1'"
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :customVisible="false"
        :columns="columnList"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
        <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :sortable="item.sortable"
          :fixed="item.fixed"
          :width="item.width"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'operate'">
              <el-button size="mini" type="text" @click="handelClick('0', scope.row)"
                >查看</el-button
              >
              <el-button
                v-if="
                  scope.row.orderStatus == 'draft' ||
                  scope.row.orderStatus == 'part_issued' ||
                  scope.row.orderStatus == 'issued' ||
                  scope.row.orderStatus == 'ongoing' ||
                  scope.row.orderStatus == 'expired'
                "
                size="mini"
                type="text"
                @click="handelClick('1', scope.row)"
                >编辑</el-button
              >
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
      <div v-show="listType === '0'" class="card">
        <CardList
          :cardTableData="tableData"
          @cardClick="handleSelectionChange"
          ref="cardListRef"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        />
      </div>
    </div>
    <SettleDialog
      v-if="settleDialogVisible"
      :settleDialogTitle="settleDialogTitle"
      :settleDialogVisible="settleDialogVisible"
      :dialogData="dialogData"
      :dialogType="dialogType"
      @settleDialogClose="settleDialogClose"
    />
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import ReportMixin from '@/pages/reportManagement/mixins/reportMixin';
  import { mapState } from 'vuex';
  import { searchColumns, columns } from './data';
  // import API from '@/api/intermodality/order';
  import orderMixin from '@/pages/intermodality/order/orderMixin';
  import CardBtn from './component/cardBtn';
  import CardList from './component/cardList';
  import SettleDialog from './component/settleDialog';
  import API from '@/api/intermodality/order';
  import BASE_API from '@/api/dataBase';

  export default {
    name: 'orderList',
    mixins: [orderMixin, ReportMixin],
    components: {
      SiruiSearch,
      SiruiTable,
      CardBtn,
      CardList,
      SettleDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      topColumns() {
        return searchColumns(this);
      },
    },
    data() {
      return {
        settleDialogTitle: '',
        settleDialogVisible: false,
        dialogType: '',
        dialogData: [],
        load: false,
        multipleSelection: [],
        // contractList: [],
        tableData: [],
        columnListDefault: columns,
        query: {
          serviceType: '',
          orderStatus: '',
          contractCode: '',
          customerName: '',
          orderCreateStartDate: '',
          orderCreateEndDate: '',
          orderCode: '',
          saleDepartmentNo: '',
          createDepartmentNo: '',
          orderCompletedStartDate: '',
          orderCompletedEndDate: '',
        },
        defaultMenuList: [
          { label: '新增', attributes: { buttonUrl: 'add' }, type: '0' },
          { label: '作废', attributes: { buttonUrl: 'cancel' }, type: '0' },
          { label: '复制', attributes: { buttonUrl: 'copy' }, type: '0' },
          { label: '查看结算状态', attributes: { buttonUrl: 'settle' }, type: '0' },
        ],
        menuButtonList: [],
        columnList: [],
        listType: '0', // 0为卡片 1为列表
        turnType: '', // 0为新增 1为编辑 2为复制 3 为查看详情
        // cardSelected: {},
      };
    },
    watch: {
      $route() {
        this.getListData();
      },
    },
    created() {
      this.$nextTick(() => {
        // this.getContractList();
        this.getButtonList();
        // this.getListData();
      });
    },
    mounted() {
      this.getCompanyList();
    },
    methods: {
      handleChange(row) {
        console.log(row, '11111');
        if (row.prop === 'createDepartmentNo') {
          this.query.createDepartmentNo = row.val;
        }
        if (row.prop === 'saleDepartmentNo') {
          this.query.saleDepartmentNo = row.val;
        }
      },
      changeMethod({ val, prop }) {
        console.log(val, prop, '这里');
        if (prop == 'platformCompanyNo') {
          this.query.createDepartmentNo = null;
          if (val) {
            this.department(val);
          } else {
            this.departmentList = [];
          }
        }
      },
      // 搜索
      search() {
        console.log(this.query, 'query');
        if (this.listType === '0') {
          this.$refs.cardListRef.setPageNum(1);
          this.getListData();
        } else {
          this.$refs.siruiTable.setPageNum(1);
          this.$refs.siruiTable.clearCheckboxReserve();
          this.getListData();
        }
      },
      //双击子类搜索列表行
      childDblclickEvent(value) {
        console.log(value, '11111');
      },
      resetBtnClick() {
        console.log('resetBtnClick');
        // if (this.$refs.siruiSearch.$refs.saleDepartmentName) {
        //   this.$refs.siruiSearch.$refs.saleDepartmentName[0].resetClick();
        // }
        // this.$refs.siruiSearch.$refs.createDepartmentName[0].resetClick();
        if (this.listType === '0') {
          this.$refs.cardListRef.setPageNum(1);
          this.$refs.cardListRef.setPageSize(10);
          this.getListData();
        } else {
          this.$refs.siruiTable.setPageNum(1);
          this.$refs.siruiTable.setPageSize(10);
          this.$refs.siruiTable.clearCheckboxReserve();
          this.getListData();
        }
      },
      handleSelectionChange(row) {
        console.log(row, '23333');
        this.multipleSelection = row;
      },
      // cardClick(row) {
      //   this.cardSelected = row;
      // },
      chooseClick(type) {
        console.log(type, '1111');
        if (type === 'add') {
          // 新增
          console.log('add');
          const query = {
            turnType: '0',
          };
          const path = {
            path: '/intermodality/orderPage',
            name: 'orderPage',
            meta: {
              keepAlive: false,
              title: '订单新增',
            },
            query,
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type === 'cancel') {
          this.invalidOrder();
        } else if (type === 'copy') {
          this.copyOrder();
        } else if (type === 'settle') {
          this.handleSettle();
        } else if (type === 'issue') {
          this.handleIssue();
        }
      },
      settleDialogClose() {
        this.settleDialogVisible = false;
        this.dialogType = '';
        this.settleDialogTitle = '';
        this.dialogData = [];
      },
      handleIssue() {
        if (this.multipleSelection.length === 0) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '请选择一条数据',
          });
        } else if (this.multipleSelection.length > 1) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '只能选择一条数据',
          });
        } else {
          let id = '';
          this.multipleSelection.forEach((item) => {
            id = item.id;
          });
          const params = {
            id: id,
          };
          this.$axios.post(API.SINGLE_ISSUE, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: res.data.msg,
              });
              this.getListData();
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: res.data.msg,
              });
            }
          });
        }
      },
      handleSettle() {
        if (this.multipleSelection.length === 0) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '请选择一条数据',
          });
        } else if (this.multipleSelection.length > 1) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '只能选择一条数据',
          });
        } else {
          const orderCodeList = [];
          this.multipleSelection.forEach((item) => {
            orderCodeList.push(item.orderCode);
          });
          const params = {
            orderCodes: orderCodeList,
            instructionNos: [],
          };
          this.$axios.post(API.SETTLE_STATUS, params).then((res) => {
            console.log(res, '-------');
            if (res.data.code === 0) {
              this.settleDialogTitle = '订单结算状态';
              this.settleDialogVisible = true;
              this.dialogType = 'order';
              this.dialogData = res.data.data || [];
            }
          });
        }
      },
      invalidOrder() {
        if (this.multipleSelection.length === 0) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '请选择一条数据',
          });
        } else if (this.multipleSelection.length > 1) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '请选择一条数据',
          });
        } else {
          const selectedData = this.multipleSelection[0];
          this.$confirm('订单作废后将无法进行结算，是否确定要作废此订单？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              // const ids = [];
              // this.multipleSelection.forEach((item) => {
              //   ids.push(item.id);
              // });
              const params = {
                // isInvalid: 1,
                id: selectedData.id,
                orderCode: selectedData.orderCode,
              };
              // params.ids = ids;
              this.loading.startLoading();
              this.$axios.post(API.ORDER_INVALID, params).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    type: 'success',
                    message: res.data.msg,
                  });
                  this.getListData();
                } else {
                  this.$message({
                    showClose: true,
                    type: 'error',
                    message: res.data.msg,
                  });
                }
              });
            })
            .finally(() => this.loading.endLoading());
        }
      },
      copyOrder() {
        console.log(this.multipleSelection, 'this.multipleSelection');
        if (this.multipleSelection.length === 0) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '请选择一条数据',
          });
        } else if (this.multipleSelection.length > 1) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '只能选择一条数据',
          });
        } else {
          const row = this.multipleSelection[0] || {};
          console.log(row, '12345');
          let path = {
            path: '/intermodality/orderPage',
            name: 'orderPage',
            meta: {
              keepAlive: true,
              title: '订单详情',
            },
            query: {
              id: row.id,
              orderCode: row.orderCode,
              turnType: '2',
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        }
      },
      handleSizeChange() {
        this.getListData();
      },
      handleCurrentChange() {
        this.getListData();
      },
      getListData() {
        let pageNum = 1;
        let pageSize = 10;
        if (this.listType === '0') {
          pageNum = this.$refs.cardListRef.page.pageNum;
          pageSize = this.$refs.cardListRef.page.pageSize;
        } else {
          pageNum = this.$refs.siruiTable.page.pageNum;
          pageSize = this.$refs.siruiTable.page.pageSize;
        }
        // if (this.query.saleDepartmentNo) {
        //   if (Object.keys(this.query.saleDepartmentNo).length > 0) {
        //     this.query.saleDepartmentNo =
        //       this.query.saleDepartmentNo.attributes.createDepartmentCode || '';
        //   }
        // }
        const params = { ...this.query, pageNum, pageSize };
        if (Array.isArray(params.contractCode)) {
          params.contractCode = params.contractCode[0].contractCode;
        }
        params.adminFlag = this.userInfo.adminFlag;
        // params.platformCompanyNo = this.userInfo.companyCode;
        this.$axios.post(API.ORDER_LIST, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.list || [];
            this.tableData.forEach((table) => {
              table.relation = false;
            });
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
            this.$refs.cardListRef.setPageTotal(res.data.data.total);
            this.$refs.cardListRef.checkAll = false;
          }
        });
      },
      handelClick(val, row) {
        // 0 是查看详情   1 是编辑
        console.log(row, '111111');
        if (val === '1') {
          console.log(val, '123445');
          let path = {
            path: '/intermodality/orderPage',
            name: 'orderPage',
            meta: {
              keepAlive: true,
              title: '订单详情',
            },
            query: {
              id: row.id,
              orderCode: row.orderCode,
              turnType: '1',
              orderCurrStatus: row.orderStatus,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          console.log(val, '123445');
          let path = {
            path: '/intermodality/orderPage',
            name: 'orderPage',
            meta: {
              keepAlive: true,
              title: '订单详情',
            },
            query: {
              id: row.id,
              turnType: '3',
              orderCode: row.orderCode,
              orderCurrStatus: row.orderStatus,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          // const query = {
          //   turnType: '3',
          //   id: row.id,
          // };
        }
      },
      changeListType(val) {
        this.listType = val;
        this.multipleSelection = [];
        this.$refs.siruiTable.clearCheckboxReserve();
      },
      // 获取公司
      async getCompanyList() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          // personCompanyCode: this.userInfo.companyCode,
        };
        const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        this.companyList = res.data.data?.personCompanyInfo.filter((item) => {
          return item.personCompanyCode != 'OAC19';
        });
        console.log(res.data.data.personCompanyInfo, this.companyList);
        if (this.userInfo.companyCode != 'OAC19') {
          this.query = {
            ...this.query,
            // platformCompanyName: this.userInfo.companyName,
            platformCompanyNo: this.userInfo.companyCode,
          };
        }
        console.log(this.query.platformCompanyNo, '---');
        if (this.query.platformCompanyNo) {
          this.department(this.query.platformCompanyNo);
        }
        this.getListData();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .main-content {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .top-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .card-btn {
        display: flex;
        flex-direction: row;
        .text {
          height: 32px;
          line-height: 32px;
          color: '#DCDFE6';
        }
      }
      .btnList {
        display: flex;
        flex-direction: row;
        .btn {
          margin-left: 10px;
        }
      }
    }
    .card {
      margin-top: 20px;
    }
  }
</style>
